<template>
<div class="input-group " >
        <multiselect
            v-model="selected"
            :options="options"
            :searchable="true"
            :loading="isLoading"
            :internal-search="false"
            :clear-on-select="false"
            :close-on-select="false"
            :preserve-search="true"
            :placeholder="placeholder"
            :label="labelKey"
            :track-by="trackBy"
            :ref="refName"
            :multiple="multiple"
            :max-height="multiple ? 150 : null"
            :limit="multiple ? 3 : null"
            selectLabel="Click to select"
            deselectLabel="Click to remove"
            @search-change="onSearchChange"
            :custom-label="customLabelFn"
            @input="onSelect"
            @keydown.enter.native.prevent="onEnterPress"
            class="form-control p-0 border-0 "
        />
    <div class="input-group-append">
      <button
          class="btn border-left-0"
          style="border: 1px solid #e8e8e8;"
          :style="!selected ? 'min-height: 42px' : ''"
          type="button"
          @click="triggerSearch"
          :disabled="isLoading"
      >
        🔍
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchSelect',
  props: {
    value: null,
    url: { type: String, required: true },
    filterParams: { type: Object, default: () => ({}) },
    customLabelFn: { type: Function, default: option => option.label },
    placeholder: { type: String, default: 'Select...' },
    labelKey: { type: String, default: 'label' },
    trackBy: { type: String, default: 'id' },
    refName: { type: String, default: 'multiselect' },
    prependOptions: { type: Array, default: () => [] },
    multiple: { type: Boolean, default: false }
  },
  data() {
    return {
      options: [],
      selected: this.value,
      isLoading: false,
      searchTerm: '',
    };
  },
  watch: {
    value(val) {
      this.selected = val;
    },
    selected(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    reset() {
      this.selected = null;
      this.options = [];
      this.searchTerm = '';
      // Close the dropdown if open
      if (this.$refs[this.refName]) {
        this.$refs[this.refName].deactivate();
      }
      // Emit reset event
      this.$emit('reset');
    },
    onSearchChange(val) {
      this.searchTerm = val;
    },
    triggerSearch() {
      // The search term is already maintained in this.searchTerm via @search-change
      if (this.searchTerm && this.searchTerm.length >= 2) {
        this.fetchOptions(this.searchTerm);
      }
    },
    onSelect(option) {
      this.selected = option;

      // Give the dropdown time to react, then blur/focus out
      this.$refs[this.refName].deactivate();
    },
    onEnterPress(event) {
      this.triggerSearch()

      // const searchTerm = event.target.value?.trim();

      // if (!searchTerm || searchTerm.length < 2) {
      //   // this.options = [];
      //   return;
      // }
      // this.fetchOptions(searchTerm);
    },
    fetchOptions(searchTerm) {
      this.isLoading = true;
      const payload = { ...this.filterParams, search: searchTerm };

      this.makeRequest("post", this.url, payload, {}, false, true, [205])
          .then((callResponse) => {
            this.$refs[this.refName].activate()
            this.isLoading = false;
            if (!callResponse.error) {
              const code = callResponse.response.data.code;
              const responseData = callResponse.response.data.data;
              const fetchedOptions = (code === 200 && responseData) ? responseData : [];

              // For multiselect, merge selected items with fetched options to keep them visible
              if (this.multiple && this.selected && this.selected.length > 0) {
                const selectedIds = new Set(this.selected.map(item => item[this.trackBy]));
                const uniqueFetched = fetchedOptions.filter(item => !selectedIds.has(item[this.trackBy]));
                this.options = [...this.prependOptions, ...this.selected, ...uniqueFetched];
              } else {
                this.options = [...this.prependOptions, ...fetchedOptions];
              }
              // Only clear selection for single select mode
              if (!this.multiple) {
                this.selected = null;
              }
            }
          });
    }
  }
};
</script>
